import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiscRoutingModule } from './misc-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StyleguideComponent } from './page/styleguide/styleguide.component';
import { SharedModule } from '../shared/shared.module';
import { ImprintPageComponent } from './page/imprint/imprint-page.component';
import { LocationPageComponent } from './page/location/location-page.component';
import { MapsModule } from '../maps/maps.module';
import { PrivacyComponent } from './page/privacy/privacy.component';
import { GeopositionHelpComponent } from './page/geoposition-help/geoposition-help.component';
import { DownloadsComponent } from './page/downloads/downloads.component';
import { DocsComponent } from './page/docs/docs.component';
import { MarkdownModule } from 'ngx-markdown';
import { AdminComponent } from './page/admin/admin.component';

@NgModule({
  declarations: [
    StyleguideComponent,
    ImprintPageComponent,
    LocationPageComponent,
    PrivacyComponent,
    GeopositionHelpComponent,
    DownloadsComponent,
    DocsComponent,
    AdminComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MiscRoutingModule,
    MapsModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild({ extend: true }),
    MarkdownModule.forChild(),
  ],
})
export class MiscModule {}
